"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var converters_1 = require("../converters");

var enums_1 = require("../enums");

var utils_1 = require("../utils");

exports.evaluateSubtitleTrack = function (subtitleTrack, variableDictionary) {
  switch (subtitleTrack.type) {
    case enums_1.SubtitleTrackType.Constant:
      {
        return {
          cues: subtitleTrack.cues,
          label: subtitleTrack.label,
          language: subtitleTrack.language
        };
      }

    case enums_1.SubtitleTrackType.Map:
      {
        var variable = variableDictionary[subtitleTrack.key];

        if (utils_1.hasValue(variable) && variable.type === enums_1.VariableValueType.SubtitleTrack) {
          return {
            label: utils_1.withDefault(variable && variable.label, subtitleTrack.defaultLabel),
            language: utils_1.withDefault(variable && variable.language, subtitleTrack.defaultLanguage),
            cues: utils_1.withDefault(variable && variable.cues, []).map(function (x) {
              return converters_1.subtitleCueConverter.fromMessage(x);
            })
          };
        } else {
          return {
            label: subtitleTrack.defaultLabel,
            language: subtitleTrack.defaultLanguage,
            cues: []
          };
        }
      }
  }
};